import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  paymentData: {},
  paymentStatus: {},
  paymentFinal: {},
  isLoading: false,
  error: "",
  hasData: false
};
const insurancePaymentSlice = createSlice({
  name: "insurancePaymentDetails",
  initialState,
  reducers: {
    insurancePaymentRequest: state => {
      state.isLoading = true;
    },
    insurancePaymentSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.paymentData = action.payload;
    },
    insurancePaymentFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = true;
    },
    insurancePaymentStatusRequest: state => {
      state.isLoading = true;
    },
    insurancePaymentStatusSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.paymentStatus = action.payload;
    },
    insurancePaymentStatusFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = true;
    },
    insurancePaymentFinalRequest: state => {
      state.isLoading = true;
    },
    insurancePaymentFinalSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.paymentFinal = action.payload;
      state.paymentStatus = {};
    },
    insurancePaymentFinalFailure: (state, action) => {
      state.error = action?.payload?.response?.data;
      state.isLoading = false;
      state.hasData = true;
    },
    resetPaymentData: state => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.paymentData = {};
    },
    resetPaymentStatus: state => {
      state.paymentStatus = {};
    },
    resetPaymentFinalStatus: state => {
      state.paymentFinal = {};
    }
  }
});
export const {
  insurancePaymentRequest,
  insurancePaymentSuccess,
  insurancePaymentFailure,
  insurancePaymentStatusRequest,
  insurancePaymentStatusSuccess,
  insurancePaymentStatusFailure,
  insurancePaymentFinalRequest,
  insurancePaymentFinalSuccess,
  insurancePaymentFinalFailure,
  resetPaymentData,
  resetPaymentStatus,
  resetPaymentFinalStatus
} = insurancePaymentSlice.actions;
export default insurancePaymentSlice.reducer;